function checkArraysHaveSameElements(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
  if (arr1.length !== arr2.length) return false;
  return arr1.every((item) => arr2.includes(item));
}

/* eslint-disable no-case-declarations */
export const createFiltersReducer = (initialState, setSearchParam) => (state, action) => {
  switch (action.type) {
    case 'SET_FILTER_VALUES': {
      const { fetchTrigger, operator } = state[action.filter];

      const filterName = action.filter;
      const { values } = action;
      const valuesAreNew = !checkArraysHaveSameElements(state[filterName].values, values);

      setSearchParam(filterName, operator, values);

      return {
        ...state,
        [action.filter]: {
          ...state[filterName],
          values,
          fetchTrigger: valuesAreNew ? !fetchTrigger : fetchTrigger,
        },
      };
    }
    case 'RESET_FILTER':
      return { ...state, [action.filter]: { ...initialState[action.filter] } };

    case 'SET_FILTER_SORT': {
      const { sort } = action;
      return {
        ...state,
        [action.filter]: {
          ...state[action.filter],
          sort,
        },
      };
    }

    case 'TOGGLE_FILTER_SORT': {
      const noSortPossible = !('sort' in initialState[action.filter]);
      if (noSortPossible) return state;
      return {
        ...state,
        [action.filter]: {
          ...state[action.filter],
          sort: state[action.filter].sort === 'ASC' ? 'DESC' : 'ASC',
        },
      };
    }

    case 'RESET_FILTERS':
      return initialState;

    default:
      return state;
  }
};

export function createSearch(filters) {
  const search = [];
  const globalSort = [];

  Object.values(filters).forEach(({
    values,
    sort,
    operator,
    formatter,
    filtersApiNames,
  }) => {
    // ❌ Early return
    if (!Array.isArray(filtersApiNames) || !Array.isArray(values)) return;

    // Simple case | one filter api and one value for this filter
    if (filtersApiNames.length === 1 && values.length === 1) {
      const filterApiName = filtersApiNames[0];
      const value = formatter(values[0]);
      search.push(
        { [filterApiName]: { [operator]: value } },
      );
    }

    // Case 2 | Several filters api with same value
    if (filtersApiNames.length > 1 && values.length === 1) {
      const value = formatter(values[0]);
      search.push({
        or: filtersApiNames.map((filterApiName) => ({ [filterApiName]: { [operator]: value } })),
      });
    }

    // Case 3 | One filter api with several values
    if (filtersApiNames.length === 1 && values.length > 1) {
      const filterApiName = filtersApiNames[0];
      search.push({
        or: values.map((value) => ({ [filterApiName]: { [operator]: formatter(value) } })),
      });
    }

    // Case 4 | Several filters api with several values
    if (filtersApiNames.length > 1 && values.length > 1) {
      let filtersArray = [];
      values.forEach((value) => {
        filtersArray = [...filtersArray, filtersApiNames.map((filterApiName) => ({ [filterApiName]: { [operator]: formatter(value) } }))];
      });
      search.push({ or: filtersArray });
    }

    if (sort) globalSort.push({ [filtersApiNames[0]]: sort });
  });

  const oneFilterOnly = search && search.length === 1;
  const severalFilters = search && search.length > 1;

  if (oneFilterOnly) return search[0];
  if (severalFilters) return { and: search };

  return null;
}

export function createSort(filters) {
  const sortApi = Object.values(filters).reduce((acc, { sort, filtersApiNames }) => {
    if (sort) {
      const sortAlreadySet = acc.some((element) => element[filtersApiNames[0]]);
      if (!sortAlreadySet) acc.push({ [filtersApiNames[0]]: sort });
    }
    return acc;
  }, []);
  if (sortApi.length > 0) return sortApi;
  return null;
}



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/utils/filters.js